import { Tooltip, TooltipTrigger, TooltipContent, TooltipProvider } from "@/components/ui/tooltip";

// Consistent, self-explanatory vocabulary across the platform.
const DEFS = {
  "Business Profile": "Everything that makes your business yours — mission, audience, goals and what sets you apart. Captured once by Top Foster and reused across everything we build (website, content, proposals, growth plan).",
  "Business DNA": "Your business profile — mission, audience, goals and what makes you different. Captured once by Top Foster and reused across everything we build (website, content, proposals, growth plan).",
  "AIPOS": "ATF's built-in AI that drafts content, suggests SEO and next steps — always reviewed by our team before anything goes out.",
  "Top Foster": "Your AI Business Strategist — it understands your business, builds your plan, and guides what we build and improve over time.",
};

export function GlossaryTerm({ term, children, className = "" }) {
  const def = DEFS[term];
  const testid = `term-${term.toLowerCase().replace(/\s+/g, "-")}`;
  if (!def) return <span className={className}>{children || term}</span>;
  return (
    <TooltipProvider delayDuration={120}>
      <Tooltip>
        <TooltipTrigger asChild>
          <span data-testid={testid}
            className={`underline decoration-dotted decoration-gold/60 underline-offset-4 cursor-help ${className}`}>
            {children || term}
          </span>
        </TooltipTrigger>
        <TooltipContent side="top" className="max-w-xs bg-navy-800 border border-gold/30 text-gray-200 text-xs leading-relaxed p-3 shadow-xl">
          {def}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
